import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { DangerouslySetHtmlContent } from '@redturtle/iovisit-theme/components';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const messages = defineMessages({
  ticket_buy_now: {
    id: 'Buy your ticket now',
    defaultMessage: 'Acquista ora il biglietto!',
  },
});

const Ticket = ({ content }) => {
  const intl = useIntl();

  if (!content.tickets_button_url && !content.tickets_embed_html) {
    return null;
  }

  const description_tickets = (
    <DangerouslySetHtmlContent
      html={content.tickets_box_description.data}
      className="embed-html"
    />
  );

  const url_label =
    content.tickets_button_label ?? intl.formatMessage(messages.ticket_buy_now);

  return content.tickets_embed_html ? (
    <DangerouslySetHtmlContent
      html={content.tickets_embed_html}
      className="embed-html"
    />
  ) : (
    <div className="tickets">
      {description_tickets && (
        <div className="tickets-text">{description_tickets}</div>
      )}
      {content.tickets_button_url && (
        <div className="tickets-link">
          <UniversalLink
            href={content.tickets_button_url}
            className="ui button primary"
          >
            {url_label}
          </UniversalLink>
        </div>
      )}
    </div>
  );
};

Ticket.propTypes = {
  content: PropTypes.object.isRequired,
};

export default Ticket;
